import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Button, Modal, ModalBody } from 'reactstrap';
import useTranslate from '../../../../hooks/useTranslate/useTranslate';
import {
  addBooking,
  bookingStatuses,
  removeProductTempBookings,
  resetBookingsState,
  setActiveSpecialCode,
} from '../../../../redux/slices/bookingsSlice/bookingsSlice';
import { resetGuestFormState } from '../../../../redux/slices/guestFormSlice/guestFormSlice';
import { resetPaymentState } from '../../../../redux/slices/paymentSlice/paymentSlice';
import BookingOverview from '../BookingOverview/BookingOverview';
import styles from './CompleteYourBookingsModal.module.css';

const CompleteYourBookingModal = ({ open, bookings = [], onContinue }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const hotels = useSelector((state) => state.belmond.hotels);
  const media = useSelector((state) => state.media.mediaUrls);

  const editingConfirmedBookings = bookings.some(
    (booking) => booking.status !== bookingStatuses.UNSUBMITTED
  );
  const { t } = useTranslate();

  const handleDiscardEditsBtnClick = async (bookings) => {
    const productCode = bookings[0].productCode;
    const { id, encryptedEmail } = bookings.find(
      (booking) => booking.status !== bookingStatuses.UNSUBMITTED
    );

    dispatch(resetGuestFormState());
    dispatch(removeProductTempBookings(bookings[0].productCode));
    dispatch(resetBookingsState());
    dispatch(resetPaymentState());

    if (id) {
      navigate(
        `/confirmation?bookingId=${id}&productCode=${productCode}&email=${encryptedEmail}`,
        { replace: true }
      );
    } else {
      navigate(`/select-room?productCode=${productCode}`, {
        replace: true,
      });
    }
  };

  const handleViewCartBtnClick = () => {
    if (bookings[0].specialCodeType && bookings[0].specialCodeValue) {
      dispatch(setActiveSpecialCode(bookings[0].specialCodeValue));
    }
    bookings.forEach((booking) => {
      dispatch(addBooking(booking));
    });
    dispatch(removeProductTempBookings(bookings[0].productCode));
    onContinue();
  };

  return (
    <Modal
      isOpen={open}
      contentClassName={styles.CompleteYourBookingModal__modalWrapper}
      scrollable
      centered
    >
      <ModalBody className={styles.CompleteYourBookingModal__modalBody}>
        <div className={styles.CompleteYourBookingModal__modalView}>
          <div className={styles.CompleteYourBookingModal__header}>
            {editingConfirmedBookings
              ? t('You are editing your booking')
              : t('Complete Your Booking')}
          </div>
          {bookings.map((booking, i) => (
            <BookingOverview
              booking={booking}
              media={media}
              numOfBookings={bookings.length}
              bookingIndex={i}
              hotel={hotels[booking.productCode]}
              key={booking.id}
            />
          ))}
        </div>
        <div className="d-flex justify-content-center mt-5">
          <Button
            onClick={
              editingConfirmedBookings
                ? () => handleDiscardEditsBtnClick(bookings)
                : () =>
                    dispatch(removeProductTempBookings(bookings[0].productCode))
            }
            className="button transparent"
          >
            {editingConfirmedBookings ? t('Discard Edits') : t('Start Again')}
          </Button>
          <div className="mx-2"></div>
          <Button className="button" onClick={handleViewCartBtnClick}>
            {t('Continue')}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

CompleteYourBookingModal.propTypes = {
  open: PropTypes.bool,
  bookings: PropTypes.array,
  onContinue: PropTypes.func,
};

export default CompleteYourBookingModal;
